"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 6h-3v9H6v3h12l4 4zm-5 7V2H2v15l4-4z"
}), 'ForumSharp');